/**
 * Pricing-related hooks for the usePriceCalculation functionality
 * These hooks break down the complex pricing logic into focused, reusable pieces
 */

// Data fetching
export { default as useItineraryData } from './useItineraryData'

// Pricing calculations
export { default as useAncillaryPricing } from './useAncillaryPricing'
export { default as useDiscountCalculation } from './useDiscountCalculation'
export { default as useFarePricingValues } from './useFarePricingValues'
export { default as useFareSelection } from './useFareSelection'
export { default as useInsurancePricing } from './useInsurancePricing'
export { default as useVatCalculation } from './useVatCalculation'

// UI formatting
export { default as usePricingItems } from './usePricingItems'
export type { PricingItem, PricingSubItem } from './usePricingItems'
